import axios from "axios";

import { BASE_URL } from "./apiBase";

const withAuth = (token) => {
  const bearerToken =
    typeof token === "string" && token.trim() ? token.trim() : null;
  return {
    headers: bearerToken ? { Authorization: `Bearer ${bearerToken}` } : {},
    withCredentials: true,
  };
};

export const getNotifications = async (token, params = {}) => {
  const response = await axios.get(`${BASE_URL}/api/Notifications`, {
    ...withAuth(token),
    params,
  });
  return response.data;
};

export const getUnreadCount = async (token) => {
  const response = await axios.get(`${BASE_URL}/api/Notifications/unread-count`, {
    ...withAuth(token),
  });
  return response.data;
};

export const markNotificationRead = async (token, id) => {
  await axios.patch(
    `${BASE_URL}/api/Notifications/${id}/read`,
    {},
    withAuth(token)
  );
};

export const markAllNotificationsRead = async (token) => {
  await axios.patch(
    `${BASE_URL}/api/Notifications/mark-all-read`,
    {},
    withAuth(token)
  );
};
